import { AD_STATUS_DERIVED } from 'sl-ad-campaign-manager-data-model';

import { useAppSelector } from 'src/utils/Hooks';
import { AdManagerPortfolio } from 'src/types/store/reduxStore';

export const useAllocationData = (
  filterFn: (filteredStore: AdManagerPortfolio[]) => AdManagerPortfolio[] = (store) => store
) => {
  const portfolioArray = useAppSelector((state) => state.adBudgetEditor.portfolioArray);

  const activePortfolios = filterFn(
    portfolioArray?.filter((portfolio: AdManagerPortfolio) => {
      return portfolio?.entity?.extendedAttributes?.statusDerived !== AD_STATUS_DERIVED.ENDED;
    })
  );

  const inActivePortfolios = filterFn(
    portfolioArray?.filter((portfolio: AdManagerPortfolio) => {
      return portfolio?.entity?.extendedAttributes?.statusDerived === AD_STATUS_DERIVED.ENDED;
    })
  );
  return { activePortfolios, inActivePortfolios };
};
